module.exports = __webpack_public_path__ + "img/DrillDown.7633e2b9.svg";